module.exports = __webpack_public_path__ + "img/pudong-patent-banner.08e0bc09.png";